import { action, observable, runInAction } from 'mobx';
import { positionGroupsController } from './positionGroupsController';
import {
  PositionGroupsCreateRequest,
  PositionGroupsUpdateRequest,
  PositionGroupsResponseItem,
  PositionGroupsRequest,
} from '../api/positionGroups';
import { ErrorInterface, ApiResult } from 'modules/core/api/globalApi';
import { parseApiError } from 'lib/parseApiError';

export interface PositionGroupsStore {
  positionGroups: PositionGroupsResponseItem[],
  error: ErrorInterface | null,
  currentPositionGroups: PositionGroupsResponseItem | null,
};

export const positionGroupsStore: PositionGroupsStore = observable({
  positionGroups: [],
  error: null,
  currentPositionGroups: null,
} as PositionGroupsStore);

export const positionGroupsActions = {

  getPositionGroups: async (request: PositionGroupsRequest): Promise<void> => {
    const response = await positionGroupsController.getPositionGroups(request);
    positionGroupsActions.handleError(response);
    runInAction(() => {
      positionGroupsStore.positionGroups = response.data?.items ?? [];
    });
  },

  clearPositionGroups: action(() => {
    positionGroupsStore.positionGroups = [];
  }),

  createPositionGroup: async (request: PositionGroupsCreateRequest): Promise<void> => {
    const response = await positionGroupsController.createPositionGroup(request);
    positionGroupsActions.handleError(response);
  },

  updatePositionGroups: async (request: PositionGroupsUpdateRequest): Promise<void> => {
    const response = await positionGroupsController.updatePositionGroup(request);
    positionGroupsActions.handleError(response);
  },

  deletePositionGroups: async (id: number): Promise<void> => {
    const response = await positionGroupsController.deletePositionGroup(id);
    positionGroupsActions.handleError(response);
  },

  restorePositionGroups: async (id: number): Promise<void> => {
    const response = await positionGroupsController.restorePositionGroup(id);
    positionGroupsActions.handleError(response);
  },

  clearError: action(() => {
    positionGroupsStore.error = null;
  }),

  handleError: action((response: ApiResult<unknown>) => {
    if (response.errorData) {
      const { errorData } = response;

      // ✅ Превращаем "сырую" ошибку в типизированный объект
      const parsedError = parseApiError(errorData, errorData?.status);
    
      positionGroupsStore.error = parsedError;
    
      // positionGroupsStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentPositionGroup: action((item: PositionGroupsResponseItem) => {     
    positionGroupsStore.currentPositionGroups = item;
  }),

  clearCurrentPositionGroup: action(() => {
    positionGroupsStore.currentPositionGroups = null;
  }),
};
